/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Activity_Bar_Error_OneInputs */



/**
* | output |
* | --- |
* | "{count} item failed" |
*
* @param {Activity_Bar_Error_OneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const activity_bar_error_one = /** @type {((inputs: Activity_Bar_Error_OneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_Bar_Error_OneInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Element fehlgeschlagen`)
	return /** @type {LocalizedString} */ (`${i?.count} item failed`)
});